import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'universal-cookie';
import {TranslationFunction} from "i18next";

const SESSION_COOKIE_NAME = 'InfoSys.IAS';
const SESSION_COOKIE_MAX_AGE = 300;

const cookies = new Cookies();

/**
 *
 */
function generateSessionId() {
  return (+ new Date()).toString(16) + '-' + uuidv4();
}

/**
 *
 * @param sessionId
 */
function setSessionId(sessionId: string) {
  cookies.set(SESSION_COOKIE_NAME, sessionId, {
    maxAge: SESSION_COOKIE_MAX_AGE,
    path: '/',
    sameSite: 'lax'
  });
}

/**
 *
 */
function sessionIdKeepAlive() {
  if(cookies.get(SESSION_COOKIE_NAME)) {
    setSessionId(cookies.get(SESSION_COOKIE_NAME));
  }
}

/**
 *
 */
function reportSessionAlive() {
  const sessionId = getSessionId();
  axios.post('ia/ka', {sid: sessionId})
    .then(() => {})
    .catch(() => {});
}

/**
 *
 */
function getSessionId() {
  if(cookies.get(SESSION_COOKIE_NAME)) {
    return cookies.get(SESSION_COOKIE_NAME);
  }
  const sessionId = generateSessionId();
  setSessionId(sessionId);
  return sessionId;
}

/**
 * Initializes tracking module - must be called exactly one from index.tsx or equivalent
 * Sets up required timers for session keepalive
 */
export function initializeTracking() {
  setInterval(sessionIdKeepAlive, 30000); // every 30 sec
  setInterval(reportSessionAlive, 3 * 60 * 1000); // every 3 min
  // also initialliy report alive in case user refreshes page before interval is executed
  reportSessionAlive();
  sessionIdKeepAlive();
}

function getResolution() {
  return window.screen.width + 'x' + window.screen.height;
}

/**
 *
 * @param page
 */
export function track(page: string) {
  console.log('Event: ' + page);
  const sessionId = getSessionId();
  axios.post('ia', {
    a: page,
    t: 'pageview',
    sid: sessionId,
    r: getResolution()
  }).then(() => {
    //
  }).catch(() => {
    //
  });
}

//
// pages
//

export const AnalyticsTranslations: {[key:string]: {translation: string[]}} = {
  "auctions": {
    translation: ['$Route.Auctions']
  },
  "auctions/article": {
    translation: ['$Route.Auctions', '$Auctions.Article']
  },
  "documents": {
    translation: ['$Route.Files']
  },
  "documents/contracts": {
    translation: ['$Route.Files', '$Route.Contracts']
  },
  "documents/declarationOfAccession": {
    translation: ['$Route.Files', '$Route.DeclarationOfAccession']
  },
  "documents/deliveryContract": {
    translation: ['$Route.Files', '$Route.DeliveryContract']
  },
  "documents/deliveryRegulation": {
    translation: ['$Route.Files', '$Route.DeliveryRegulation']
  },
  "documents/it": {
    translation: ['$Route.Files', '$Route.IT']
  },
  "documents/logistics": {
    translation: ['$Route.Files', '$Route.Logistics']
  },
  "documents/maintenance": {
    translation: ['$Route.Files', '$Route.Maintenance']
  },
  "documents/qualityManagement": {
    translation: ['$Route.Files', '$Route.QualityManagement']
  },
  "documents/globalGap": {
    translation: ['$Route.Files', '$Route.GlobalGAP']
  },
  "documents/globalGap-generalRegulations": {
    translation: ['$Route.Files', '$Route.GeneralRegulations']
  },
  "documents/globalGap-FlowersOrnamentalPlants": {
    translation: ['$Route.Files', '$Route.FlowersOrnamentalPlants']
  },
  "documents/globalGap-FlowersOrnamentalPlants-Requirements": {
    translation: ['$Route.Files', '$Route.Requirements']
  },
  "documents/globalGap-FlowersOrnamentalPlants-SampleDocumentsBP": {
    translation: ['$Route.Files', '$Route.SampleDocumentsBP']
  },
  "documents/GRASPV2": {
    translation: ['$Route.Files', '$Route.GRASPV2']
  },
  "documents/globalGap-FruitVegetablesHerbs": {
    translation: ['$Route.Files', '$Route.FruitVegetablesHerbs']
  },
  "documents/globalGap-FruitVegetablesHerbs-Requirements": {
    translation: ['$Route.Files', '$Route.Requirements']
  },
  "documents/globalGap-FruitVegetablesHerbs-SampleDocuments": {
    translation: ['$Route.Files', '$Route.SampleDocuments']
  },
  "documents/globalGap-FruitVegetablesHerbs-SampleDocuments-CBPlants": {
    translation: ['$Route.Files', '$Route.CBPlants']
  },
  "documents/globalGap-FruitVegetablesHerbs-SampleDocuments-FVFruitsVegetables": {
    translation: ['$Route.Files', '$Route.FVFruitsVegetables']
  },
  "documents/membership": {
    translation: ['$Route.Files', '$Route.Membership']
  },
  "documents/rvPrices": {
    translation: ['$Route.Files', '$Route.RVPrices']
  },
  "documents/scaleOfCharges": {
    translation: ['$Route.Files', '$Route.ScaleOfCharges']
  },
  "documents/statutes": {
    translation: ['$Route.Files', '$Route.Statutes']
  },
  "documents/systems": {
    translation: ['$Route.Files', '$Route.Systems']
  },
  "home": {
    translation: ['$Route.Home']
  },

  "logistics-avalanche": {
    translation: ['$Route.InventoryAvalanche']
  },
  "logistics-avalanche/account/lt/region": {
    translation: ['$Route.InventoryAvalanche', 'Regionen - Details']
  },
  "logistics-avalanche/account/region": {
    translation: ['$Route.InventoryAvalanche', 'Regionen']
  },
  "logistics-avalanche/account/lt": {
    translation: ['$Route.InventoryAvalanche', 'Details']
  },
  "logistics-avalanche-movements": {
    translation: ['$Route.InventoryAvalanche', 'Movements']
  },

  "logistics": {
    translation: ['$Route.Inventory']
  },
  "logistics/account": {
    translation: ['$Route.Inventory', '$Inventory.Account']
  },
  "logistics/account/market": {
    translation: ['$Route.Inventory', '$Inventory.Account', '$InventoryAccountType.Market']
  },
  "mailbox": {
    translation: ['$Route.MailBox']
  },
  "mailbox_management": {
    translation: ['$Route.MailBoxManagement']
  },
  "offer_vrm": {
    translation: ['$Route.Offers']
  },
  "offer_vrm/detail": {
    translation: ['$Route.Offers', '$Offer.VSTGrp']
  },
  "offer_vrm_public": {
    translation: ['$Route.OffersGuest']
  },
  "preliminary_data": {
    translation: ['$Route.AdvanceData']
  },
  "preliminary_data/customer": {
    translation: ['$Route.AdvanceData', '$Route.SalesCustomer']
  },
  "preliminary_data/supplier": {
    translation: ['$Route.AdvanceData', '$Route.SalesSupplier']
  },
  "sales": {
    translation: ['$Route.Sales']
  },
  "sales/customer": {
    translation: ['$Route.Sales', '$Route.SalesCustomer']
  },
  "sales/customer/details": {
    translation: ['$Route.Sales', '$Route.SalesCustomer', '$Sales.markt']
  },
  "sales/supplier": {
    translation: ['$Route.Sales', '$Route.SalesSupplier']
  },
  "sales/supplier/details": {
    translation: ['$Route.Sales', '$Route.SalesSupplier', '$Sales.markt']
  },
  "tourdata": {
    translation: ['$Route.TourData']
  },

  "tourdata-avalanche": {
    translation: ['$Route.TourDataAvalanche']
  },

  "infosys_statistics": {
    translation: ['$Route.AnalyticsReport']
  },
  "user_management": {
    translation: ['$Route.UserManagement']
  },
  "user_management/new": {
    translation: ['$Route.UserManagement', 'Neu']
  },
  "user_management/edit": {
    translation: ['$Route.UserManagement', 'Bearbeiten']
  },
  "document_management": {
    translation: ['$Route.FileManagement']
  },
  "onboarding": {
    translation: ['Onboarding']
  },
  "login": {
    translation: ['Login']
  },
  "registration_notice": {
    translation: ['Registrierung']
  },
  "profile": {
    translation: ['$Route.Profile']
  }
};

export const translateAnalyticsPage = (page: string, t: TranslationFunction) => {
  if(typeof AnalyticsTranslations[page] === 'undefined') {
    return page;
  }
  const translation = AnalyticsTranslations[page].translation;

  return translation.map(part => {
    if(part.startsWith('$')) {
      return t(part.substr(1));
    }
    return part;
  }).join(' > ');
};